import * as React from "react";
const RegulatoryComplianceSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#fff" rx={24} />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#DFE2EB"
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#2C2F38"
      d="m37.37 22.756-6.126-6.125a.876.876 0 0 0-.619-.256h-10.5a1.75 1.75 0 0 0-1.75 1.75v19.25a1.75 1.75 0 0 0 1.75 1.75h15.75a1.75 1.75 0 0 0 1.75-1.75v-14a.875.875 0 0 0-.256-.62Zm-5.87-3.394 3.138 3.138H31.5v-3.138Zm4.375 18.013h-15.75v-19.25h9.625v5.25a.875.875 0 0 0 .875.875h5.25v13.125Z"
    />
  </svg>
);
export default RegulatoryComplianceSVG;
